import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import IPOCalenderListDisplay from './IPOCalenderListDisplay';

class IPOCalenderWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>IPO Calender Details</title>
          <link rel="canonical" href="https://www.vizfm.com/ipoCalender" />
          <meta name="description" content="IPO Calender for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row><Col>IPO Calender</Col></Row>
          <Row>
            <Col><IPOCalenderListDisplay limt={100}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default IPOCalenderWrap;
